<template>
  <div class="pay">
    <header>
      <div class="tip">
        <p>你好，欢迎使用微信付款！</p>
      </div>
      <div class="logo">
        <p>
          <img src="~@assets/images/purchase/wx_logo.png" alt="">
          <span>我的收银台</span>
        </p>
      </div>
    </header>
    <div class="content">
      <ul :class="['details', {'hide': hideDetail}]">
        <div>
          正在使用即时到账交易
        </div>
        <li class="bold">{{ detail.subject }}</li>
        <li>
          收款方：南京艺赛旗智能科技有限公司
        </li>
        <li>订单号：{{ detail.outTradeNo }}</li>
        <li>商品名称：{{ detail.subject }}</li>
        <li>商品描述：{{ detail.orderDesc }}</li>
        <li>交易金额：{{ detail.dctPrice }}</li>
        <li class="money"><strong>{{ detail.dctPrice }}</strong>元</li>
      </ul>
      <div class="payment">
        <div class="qrcode-box">
          <div class="qrcode" ref="qrCodeUrl"></div>
          <p>
            <img src="~@assets/images/purchase/sao.png" alt="">
            扫一扫开始支付
          </p>
          <img class="tip" src="~@assets/images/purchase/sao_bg.png" alt="">
        </div>
        <span :class="['detail-btn']" @click="hideDetail = !hideDetail">订单详情</span>
      </div>
    </div>
  </div>
</template>

<script>
import { getOrderDetail, getOrderStatus } from '@api/purchase'
import QRcode from 'qrcodejs2'
export default {
  name: 'PayWx',
  data () {
    return {
      hideDetail: true,
      detail: {},
      qrCode: null,
      timer: null
    }
  },
  mounted () {
    this.getDetail()
    this.getOrderStatus()
  },
  methods: {
    getDetail () {
      const { no, qrcode } = this.$route.query
      this.qrCode = new QRcode(this.$refs.qrCodeUrl, {
        text: qrcode,
        width: 168,
        height: 168,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: QRcode.CorrectLevel.H
      })
      getOrderDetail(no).then(res => {
        this.detail = res
      })
    },
    async getOrderStatus () {
      const { no } = this.$route.query
      const res = await getOrderStatus(no)
      if (res.code === 80001) {
        this.$router.push('/robot&studio/purchase?step=2&type=2')
        return true
      }
      this.timer = setTimeout(() => {
        this.getOrderStatus()
      }, 2000)
    }
  },
  beforeDestroy () {
    clearTimeout(this.timer)
    this.timer = null
  }
}
</script>

<style lang="less" scoped>
.pay{
  header{
    .tip{
      height: 30px;
      line-height: 30px;
      font-size: 12px;
      color: #fff;
      background-color: #4D4D4D;
      p{
        width: 950px;
        margin: 0 auto;
        text-align: right;
      }
    }
    .logo{
      height: 60px;
      line-height: 60px;
      font-size: 12px;
      color: #999999;
      background:rgba(255,255,255,1);
      box-shadow:0px 1px 0px 0px rgba(221,221,221,1);
      p{
        width: 950px;
        margin: 0 auto;
        img{
          padding-right: 12px;
          margin-right: 12px;
          border-right: 1px solid #DDDDDD;
          display: inline-block;
        }
      }
    }
  }
  .content{
    width: 950px;
    margin: 0 auto;
    .details{
      font-size: 12px;
      color: #333;
      padding: 24px;
      line-height: 22px;
      position: relative;
      &.hide{
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
        padding-right: 70%;
        li{
          display: inline-block;
          margin-right: 10px;
        }
      }
      .bold{
        line-height: 24px;
      }
      .money{
        position: absolute;
        font-size: 12px;
        color: #333333;
        line-height: 24px;
        bottom: 15px;
        right: 0;
        strong{
          font-size: 22px;
          color: #FF6600;
          font-weight: bold;
          margin-right: 8px;
        }
      }
    }
    .payment{
      position: relative;
      border: 3px solid #b3b3b3;
      border-left: 0;
      border-right: 0;
      background: #fff;
      overflow: hidden;
      min-height: 460px;
      text-align: center;
      .detail-btn{
        position: absolute;
        top: 0;
        right: 24px;
        background: #b3b3b3;
        color: #fff;
        font-size: 12px;
        line-height: 24px;
        padding: 0 7px;
        font-weight: 700;
        cursor: pointer;
      }
      .qrcode-box{
        width:182px;
        height:234px;
        background:rgba(255,255,255,1);
        border:1px solid rgba(238,238,238,1);
        box-shadow:1px 1px 2px 0px rgba(204,204,204,0.25);
        margin: 24px auto 15px;
        position: relative;
        .tip{
          position: absolute;
          top: -65px;
          right: -210px;
        }
        .qrcode{
          width: 168px;
          height: 168px;
          margin: 7px auto 14px;
        }
        p{
          font-size: 12px;
          color: #666666;
          line-height: 24px;
        }
      }
    }
  }
}
</style>
